<app-action-icon [fontAwesomeIconClass]="'icnFolderOpen'" [iconLabel]="'Open Folder'" [toolTip]="'Open ' + folderData.FolderName" (click)="onSelected()" [isMobile]="isMobile"></app-action-icon>
